import { Component, OnDestroy, OnInit } from '@angular/core';
import { IWeissmanModalComponent } from '../../../Compliance/WeissmanModalService';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ModalWrapperComponent } from '../../../UI-Lib/Modal-Wrapper/modalWrapper.component';
import { AttachmentBundlerComponent } from '../attachmentBundler.component';
import { AttachmentBundlerContext } from '../../attachment.modal.model';
import {
    MessageModalService,
    MessageModalButtons,
    MessageModalDisplayMode,
} from '../../../UI-Lib/Message-Box/messageModal.service';
import { AttachmentBundlerService } from '../attachmentBundler.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

export interface AttachmentBundlerModalParams {
    /** Dialog-specific context for prepopulation and already-attached disable rules */
    dialogContext?: AttachmentBundlerContext;
}

@Component({
    selector: 'bundler-modal',
    templateUrl: './bundlerModal.component.html',
    imports: [ModalWrapperComponent, AttachmentBundlerComponent],
    providers: [AttachmentBundlerService],
})
export class AttachmentBundlerModalComponent
    implements OnInit, OnDestroy, IWeissmanModalComponent<AttachmentBundlerModalParams, string[]>
{
    constructor(
        private readonly _bsModalRef: BsModalRef,
        private readonly _messageModalService: MessageModalService,
        private readonly _attachmentBundlerService: AttachmentBundlerService,
    ) {}

    params: AttachmentBundlerModalParams;
    result: string[];

    private _hasSelectedDocuments: boolean = false;
    private _destroy$: Subject<void> = new Subject();

    ngOnInit(): void {
        if (!this.params?.dialogContext) {
            this._showMissingDialogContextError();
            return;
        }

        this._attachmentBundlerService.selectedAttachments$.pipe(takeUntil(this._destroy$)).subscribe((x) => {
            this._hasSelectedDocuments = x.length > 0;
        });
    }

    ngOnDestroy(): void {
        this._destroy$.next();
        this._destroy$.complete();
    }

    onDialogSubmit(selectedIds: string[]): void {
        this.result = selectedIds;
        this._bsModalRef.hide();
    }

    async cancel(): Promise<void> {
        if (this._hasSelectedDocuments) {
            try {
                await this._messageModalService.open({
                    displayMode: MessageModalDisplayMode.SingleMessage,
                    message: 'You have selected documents. Are you sure you want to discard your selections?',
                    buttons: MessageModalButtons.OKCancel,
                });
            } catch (_err) {
                return;
            }
        }
        this._bsModalRef.hide();
    }

    private _showMissingDialogContextError(): void {
        void this._messageModalService
            .open({
                displayMode: MessageModalDisplayMode.SingleMessage,
                message: 'Unable to open Bundle Attachments because required context is missing.',
                buttons: MessageModalButtons.OK,
            })
            .catch(() => undefined)
            .finally(() => {
                this._bsModalRef.hide();
            });
    }
}
